module.exports = __webpack_public_path__ + "media/images/Facebook-559f4afbac09514be9b71abe522f57d7.png";